import { Inject, Injectable, Injector } from '@angular/core';
import { HttpClientService } from '../../util-services/root-services/http-client.service';
import { AppVersionSetting } from '@app/models/server/app-version.model';
import { Observable } from 'rxjs';
import { environment } from '@src/environments/environment';
import { AlertController } from '@ionic/angular/standalone';
import { StorageUtilLibService } from '@b2b/storage-util-lib';
import { DOCUMENT } from '@angular/common';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';

const APP_UPDATE_AVAILABLE: number = Number(2);

@Injectable({
  providedIn: 'root',
})
export class AppSettingsService {
  // appVersionSettings: AppVersionSetting;
  isExitAppPresented: boolean = Boolean(false);
  isUpdateAppPresented: boolean = Boolean(false);
  public appUpdateInfo: any;
  public appUpdateInfoModule: any;

  appVersionSetting: AppVersionSetting;

  next: string = String('FBK');

  constructor(
    private httpClientService: HttpClientService,
    private alertController: AlertController,
    @Inject(DOCUMENT) private readonly document: Document,
    private storageUtilLibService: StorageUtilLibService,
    private b2bDeviceUtilService: B2bDeviceUtilService,
    private injector: Injector,
  ) {
    // LoggerService.log('Inside app setting services');
    // LoggerService.log('platforms ', this.platform.platforms());
    if (environment?.mobileApp) {
      try {
        import('@capawesome/capacitor-app-update')
          .then((module) => {
            this.appUpdateInfoModule = module;
            module?.AppUpdate?.getAppUpdateInfo()
              .then((appUpdateInfo) => {
                this.appUpdateInfo = appUpdateInfo;
              })
              .catch((e) => {});
          })
          .catch((e) => {});
      } catch (e) {}
    }
  }

  public getAppVersion(): Observable<AppVersionSetting> {
    return this.httpClientService.get(`shortstay/app-settings`, {}, true);
  }

  public setAppCacheVersion(appVersionSettings: AppVersionSetting): void {
    if (environment?.mobileApp) {
      const platform: string = this.b2bDeviceUtilService?.getAppPlatform();
      if (platform === 'ios') {
        if (environment.cacheVersion <= appVersionSettings?.IOS_CACHE_VERSION) {
          environment.cacheVersion = Number(
            appVersionSettings?.IOS_CACHE_VERSION,
          );
        }
      } else if (platform === 'android') {
        if (
          environment.cacheVersion <= appVersionSettings?.ANDROID_CACHE_VERSION
        ) {
          environment.cacheVersion = Number(
            appVersionSettings?.ANDROID_CACHE_VERSION,
          );
        }
      }
    } else {
      environment.cacheVersion = Number(appVersionSettings?.WEB_CACHE_VERSION);
    }

    this.storageUtilLibService.currentCacheVersion = Number(
      environment.cacheVersion,
    );
    this.storageUtilLibService.clearOldCache();
  }

  public verifyAppVersion(appVersionSettings: AppVersionSetting) {
    if (appVersionSettings && environment?.mobileApp) {
      const platform: string = this.b2bDeviceUtilService?.getAppPlatform();
      if (platform === 'ios') {
        this.verifyIOSAppVersion(appVersionSettings);
      } else if (platform === 'android') {
        this.verifyAndroidAppVersion(appVersionSettings);
      } else if (platform === 'web') {
      }
    }
  }

  async presentAlertConfirm() {
    const alert = await this.alertController.create({
      cssClass: 'my-alert',
      header: '',
      message: `
                    <div class="img">
                        <img src="https://static.bag2bag.in/new-assets/india/new-app/icons/update.webp" alt="g-maps" style="width: 100px;height: 110px;object-fit: contain;">
                    </div>
                    <div class="title">
                        App Update Required
                    </div>
                    <div class="desc">
                        We have added New Offers and Features to make your experience seamless
                    </div>
                `,
      backdropDismiss: false,
      buttons: [
        {
          text: 'Update Now',
          cssClass: 'update-button',
          handler: () => {
            this.isUpdateAppPresented = false;
            this.openAppStore().then();
          },
        },
      ],
    });
    this.isUpdateAppPresented = true;
    await alert.present();
  }

  openReferModal() {
    import('@app/services/util-services/lazy-services/refer-util.service').then(
      (r) => {
        const s = this.injector.get(r.REFER_UTIL_SERVICE);
        s.openReferModal().then();
      },
    );
  }

  openFeedback() {
    import(
      '@app/services/util-services/lazy-services/feedback-util.service'
    ).then((r) => {
      const s = this.injector.get(r.FEEDBACK_API);
      s.openFeedbackModal().then();
    });
  }

  async exitAlert() {
    const alert = await this.alertController.create({
      cssClass: 'my-alert',
      header: 'Do you want to exit?',
      backdropDismiss: false,
      buttons: [
        {
          text: 'Exit',
          cssClass: 'cancel-button',
          handler: () => {
            // LoggerService.log('Exit button clicked!!!!');
            this.isExitAppPresented = false;
            import('@capacitor/app').then((module) => {
              module?.App?.exitApp().then();
            });
          },
        },
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'success-button',
          handler: () => {
            this.isExitAppPresented = false;
            // LoggerService.log('Cancelled button clicked!!!!');
          },
        },
      ],
    });

    this.isExitAppPresented = true;
    await alert.present();
  }

  async handleCloseButton() {
    if (this.isUpdateAppPresented) {
      return;
    }
    if (this.isExitAppPresented) {
      return;
    }

    switch (this.next) {
      case 'FBK':
        this.openFeedback();
        this.next = 'REFER';
        break;
      case 'REFER':
        this.openReferModal();
        this.next = 'EXIT';
        break;
      case 'EXIT':
        this.exitAlert().then();
        this.next = 'FBK';
        break;
    }
  }

  private verifyAndroidAppVersion(appVersionSettings: AppVersionSetting): void {
    // LoggerService.log('verifyAndroidAppVersion');
    if (this.appUpdateInfo) {
      if (this.appUpdateInfo?.updateAvailability !== APP_UPDATE_AVAILABLE) {
        return;
      }
      this.performImmediateAndroidUpdate().then();
    } else {
      if (
        appVersionSettings?.SUPPORTED_APP_VERSIONS?.length > 0 &&
        appVersionSettings?.SUPPORTED_APP_VERSIONS?.indexOf(
          environment.appVersion,
        ) === -1
      ) {
        this.presentAlertConfirm().then((r) => {});
      }
    }
  }

  private verifyIOSAppVersion(appVersionSettings: AppVersionSetting): void {
    // LoggerService.log('this.appUpdateInfo ', this.appUpdateInfo);
    if (this.appUpdateInfo) {
      if (this.appUpdateInfo?.updateAvailability !== APP_UPDATE_AVAILABLE) {
        return;
      }
      this.presentAlertConfirm().then();
    } else {
      // Fallback mechanism
      if (
        appVersionSettings?.SUPPORTED_IOS_APP_VERSIONS?.length > 0 &&
        appVersionSettings?.SUPPORTED_IOS_APP_VERSIONS?.indexOf(
          environment.iosAppVersion,
        ) === -1
      ) {
        this.presentAlertConfirm().then((r) => {});
      }
    }
  }

  async openAppStore() {
    // LoggerService.log('Inside openAppStore()');
    if (this.appUpdateInfo) {
      // LoggerService.log('Inside openAppStore() before opening app store');
      await this.appUpdateInfoModule?.AppUpdate?.openAppStore();
    } else {
      // fallback
      this.openUrl();
    }
  }

  openUrl() {
    const platform: string = this.b2bDeviceUtilService?.getAppPlatform();
    if (platform === 'ios') {
      this.openUrlInNative(
        'https://apps.apple.com/us/app/bag2bag-rooms/id1563969368',
      );
      // LoggerService.log('open apple playstore url: ', value);
    } else if (platform === 'android' || platform === 'web') {
      this.openUrlInNative(
        'https://play.google.com/store/apps/details?id=com.ionicframework.projectx956620',
      );
    }
  }

  openUrlInNative(url: string) {
    import('@capacitor/app-launcher').then((module) => {
      module?.AppLauncher?.openUrl({
        url,
      }).then();
    });
  }

  async performImmediateAndroidUpdate() {
    if (this.appUpdateInfo?.updateAvailability !== APP_UPDATE_AVAILABLE) {
      return;
    }
    if (this.appUpdateInfo?.immediateUpdateAllowed) {
      await this.appUpdateInfoModule?.AppUpdate?.performImmediateUpdate();
    }
  }

  setupTawk() {
    if (environment?.webApp) {
      const s1 = this.document.createElement('script');
      s1.async = true;
      s1.src = 'https://embed.tawk.to/6391d82edaff0e1306db93a8/1gjor8uka';
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');
      this.document.body.appendChild(s1);
    } else {
      this.b2bDeviceUtilService
        .openSite('https://tawk.to/chat/6391d82edaff0e1306db93a8/1gjor8uka')
        .then((r) => console.log('Tawk is opening'));
    }
  }
}
